import { Device } from './lib/api_config';
import { formatDistance } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { enUS, ja } from 'date-fns/locale';
import i18n from 'i18next';
import format from 'date-fns/format';
import { IVideoDuration } from './pages/NewAnalysisJob';
import { ITypeTableData } from 'scorer-ui-kit/dist/Tables';

export const getTimeSince = (date: string) => {
  const lang = i18n.language === 'ja' ? ja : enUS;
  try {
    if (date) {
      const result = formatDistance(
        new Date(date), new Date(),
        { locale: lang, addSuffix: true, includeSeconds: true }
      );
      const resultStr = (result.charAt(0).toUpperCase() + result.slice(1)).replace('か月', 'ヶ月').replace('About', '').replace('約', '');
      if(i18n.language === 'ja'){
        let stringIndex=0;
        for (let i=0;  i <resultStr.length; i++) {
          if (isNaN(parseInt(resultStr[i]))) {
            stringIndex = i;
            break;
          }
        }
        return stringIndex === 0 ? resultStr : resultStr.slice(0, stringIndex) + ' ' + resultStr.slice(stringIndex);
      } else {
        return resultStr;
      }
    }
  } catch (err) {
    // console.log(err);
    // suppress invalid dates
    return '-';
  }
};

export const sortDevices = (devices: Device[], sortType: string, sortBy: string) => {
  if (sortBy === 'name') {
    devices.sort((a, b) => {
      if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
      if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
      return 0;
    });
  }
  if (sortType === 'desc') {
    devices.reverse();
  }
  return devices;
};

export const formatDateToJST = (date: string, dateFormat: string) => {
  try {
    if (date) {
      return formatInTimeZone(new Date(date), 'Asia/Tokyo', dateFormat);
    }
  } catch (err) {
    console.log(err);
  }
  return '-';
};

export const formatDate = (date: string, unit?:string) => {
  try {
    if (date) {
      if(unit) {
        return format(new Date(date), 'yyyy/MM/dd - HH:mm') + ' ' + unit;
      } else {
        return format(new Date(date), 'yyyy/MM/dd - HH:mm');
      }
    }
  } catch (err) {
    console.log(err);
  }
  return '-';
};

export const secToMinHours = (seconds : number) : IVideoDuration => {

  if(seconds >= 3600) {
    const hours = Math.floor(seconds / 3600);
    const nonHourSecs = seconds/3600;
    const minutes = Math.floor(nonHourSecs/ 60);
    return {hours, minutes};
  }

  const hours = 0;
  const calcMinutes = Math.floor(seconds /60);
  const minutes = calcMinutes < 1
    ? 1
    : calcMinutes;

  return {hours, minutes};
};
export const emptyTable : ITypeTableData = [
  {
    columns: []
  }
];


/**
 *  round to the minute bellow but preventing 0
 */
export const secToMins = (seconds: number) : number => {
  const minutes = Math.floor(seconds /60);

  if(minutes < 1) {
    return 1;
  }

  return minutes;
};
